import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import 'rxjs/add/operator/map';
import { configURI } from '../../../shared/apiUrlConfig';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';

@Injectable()
export class DueDiligenceService {
  load
  
  private upadteDocUrl = '/DueDiligence/update'
  private documentValues = "/DueDiligence";
  private getDocUrl = "/DueDiligence/";
  private deleteUrl = '/DueDiligence/';
  private downloadPreviewUrl = '/Download';

  // Lambda API's
  url = environment.configURI;
  private documentsList = '/documents/GetDocumentTypesByCategory?Category=DUEDILIGENCE';
  private postDocument = '/dueDiligence';
  private ClientGetListOfDocuments ='/client/dueDiligence/vendor/';
  private getListOfDocuments ='/dueDiligence/vendor/';
  private updateDocumentByID = '/dueDiligence/document/';
  private deleteDocumentByID = '/dueDiligence/document/';

  constructor(private httpClient: HttpClient, private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
  }

  private messageSource = new BehaviorSubject('');
  currentMessage = this.messageSource.asObservable();

  changeMessage(message) {
    this.messageSource.next(message);
  }

  listOfDocuments() {
    return this.httpClient.get(`${this.url}${this.documentsList}`).catch(this.userFriendlyMsgs.errorHandler);
  }

  submitDocumentVal(body) {
    return this.httpClient.post(this.url + this.postDocument, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  getDueDocuments(agentId) {
    let role = parseInt(localStorage.getItem("RoleVal"))
        if (role === 8) {
          return this.httpClient.get(`${this.url}${this.ClientGetListOfDocuments}${agentId}`).catch(this.userFriendlyMsgs.errorHandler);
        } else {
          return this.httpClient.get(`${this.url}${this.getListOfDocuments}${agentId}`).catch(this.userFriendlyMsgs.errorHandler);
        }
  }

  updateDueDocuments(Id, body) {
    return this.httpClient.put(`${this.url}${this.updateDocumentByID}${Id}`, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  deleteDueDocuments(Id, agentId) {
    return this.httpClient.delete(`${this.url}${this.deleteDocumentByID}${agentId}${'/'}${Id}`).catch(this.userFriendlyMsgs.errorHandler);
  }

  previewDocument(fileName) {
    return this.httpClient.get(`${this.url}${this.downloadPreviewUrl}?filePath=${fileName}`).catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/due-diligence/due-diligence.service.ts